import { createActionGroup, props } from '@ngrx/store';
import { IRoute } from '@core/state/ui/route.model';

export enum ShowAuthAlertBannerStatus {
  true = 'true',
  false = 'false',
}

export enum ShowCookieAlertBannerStatus {
  true = 'true',
  false = 'false',
}

export const AUTH_ALERT_COOKIE_KEY = 'auth_alert_key';
export const COOKIE_ALERT_COOKIE_KEY = 'syrf_cookie_prefs';

export const coreActions = createActionGroup({
  source: 'Core',
  events: {
    'set auth alert display status': props<{
      status: ShowAuthAlertBannerStatus;
    }>(),
    'set cookie alert display status': props<{
      status: ShowCookieAlertBannerStatus;
    }>(),
    'core init': props<{
      authAlertStatus: ShowAuthAlertBannerStatus;
      cookieAlertBannerStatus: ShowCookieAlertBannerStatus;
    }>(),
    'add routes': props<{ routes: IRoute[] }>(),
    'set change detection visualisation': props<{
      visualiseChangeDetection: boolean;
    }>(),
    'set debuggers': props<{ showDebuggers: boolean }>(),
    'set logging': props<{ showLogging: boolean }>(),
  },
});
